import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'
import AttributeLog from '@/views/Project/Observation/components/attributeLog/attributeLog.vue'

@Component({
    inheritAttrs: false,
    name: 'log-user',
    components: { LogTemplate, AttributeLog },
})
export default class LogUser extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log

    get customString() {
        switch (this.log.logEventName) {
            case 'passwordUpdated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }`
            case 'passwordResetInitiated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }`
            case 'userFirstNameUpdated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }`
            case 'userMiddleNameUpdated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }_${this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'}`
            case 'userLastNameUpdated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }`
            case 'userPhoneUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'userCardIdUpdated':
                if (this.log.actingUser) {
                    return `${this.log.logEventName}_${
                        this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                    }`
                }
                return `${this.log.logEventName}.system_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'userIsSuperuserUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'userIsEnabledUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'userJobTitleUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'userAvatarFileIdUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'userEmployerUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'userPrimaryEmailUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'userSecondaryEmailsUpdated':
            case 'userPendingEmailsUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['added'].length > 0 ? 'notNull(new)' : 'isNull(new)'
                }`
            default:
                return this.log.logEventName
        }
    }

    newAttachment: any = null
    oldAttachment: any = null
    attachment: any = null
    editorJS: any = null
}
